import * as Yup from 'yup';

export const initialValues = {
  course: '',
  module: '',
};

export const validationSchema = Yup.object().shape({});
